import { Component, Input } from '@angular/core';
import { ECategoryOfWarehouse, Invoice } from '@models';
import { compareStringDatesWithoutTime } from '@shared';
import * as moment from 'moment';
import {
  categoryOfWarehouseIn,
  dateIsValid,
  statusIn,
  updateDateFormat,
} from './invoice-transport-process-informer.utils';

@Component({
  selector: 'app-invoice-transport-process-informer',
  templateUrl: './invoice-transport-process-informer.component.html',
  styleUrls: ['./invoice-transport-process-informer.component.scss'],
})
export class InvoiceTransportProcessInformerComponent {
  displayedText: string = '';

  @Input() set invoice(invoice: Invoice) {
    this.detectStatus(invoice);
  }

  detectStatus(invoice: Invoice): void {
    if (!invoice) {
      return;
    }

    const today = moment().format('DD.MM.YYYY');

    const invoiceStatuses = ['7', '8'];
    const DateMoving: string = dateIsValid(invoice.authenticData.DateMoving) ? updateDateFormat(invoice.authenticData.DateMoving) : null;
    const DateReturnCargo: string = dateIsValid(invoice.authenticData.DateReturnCargo) ? updateDateFormat(invoice.authenticData.DateReturnCargo) : null;
    const ActualDeliveryDate: string = dateIsValid(invoice.authenticData.ActualDeliveryDate) ? invoice.authenticData.ActualDeliveryDate : null;
    const StatusCode = invoice.authenticData.StatusCode;
    const CategoryOfWarehouse = invoice.authenticData.CategoryOfWarehouse;

    const LastDayPostomat: boolean = [
      () => categoryOfWarehouseIn([ECategoryOfWarehouse.Postomat], CategoryOfWarehouse),
      () => statusIn(invoiceStatuses, StatusCode),
      () => DateMoving && compareStringDatesWithoutTime(DateMoving, today, true) >= 0,
      () => !DateReturnCargo || compareStringDatesWithoutTime(DateReturnCargo, DateMoving, true) > 0,
    ].every(fn => fn());

    const LastDayStore: boolean = [
      () => categoryOfWarehouseIn([
        ECategoryOfWarehouse.Store,
        ECategoryOfWarehouse.DropOff,
      ], CategoryOfWarehouse),
      () => statusIn(invoiceStatuses, StatusCode),
      () => DateMoving && compareStringDatesWithoutTime(DateMoving, today, true) >= 0,
      () => !DateReturnCargo || compareStringDatesWithoutTime(DateReturnCargo, DateMoving, true) > 0,
    ].every(fn => fn());

    const AutoReturnPostomat: boolean = [
      () => categoryOfWarehouseIn([ECategoryOfWarehouse.Postomat], CategoryOfWarehouse),
      () => statusIn(invoiceStatuses, StatusCode),
      () => DateMoving && compareStringDatesWithoutTime(DateMoving, today, true) >= 0,
      () => DateReturnCargo
        && compareStringDatesWithoutTime(DateReturnCargo, today, true) >= 0
        && compareStringDatesWithoutTime(DateMoving, DateReturnCargo, true) >= 0,
    ].every(fn => fn());

    const AutoReturnStore: boolean = [
      () => categoryOfWarehouseIn([
        ECategoryOfWarehouse.Store,
        ECategoryOfWarehouse.DropOff,
      ], CategoryOfWarehouse),
      () => statusIn(invoiceStatuses, StatusCode),
      () => DateMoving && compareStringDatesWithoutTime(DateMoving, today, true) >= 0,
      () => DateReturnCargo
        && compareStringDatesWithoutTime(DateReturnCargo, today, true) >= 0
        && compareStringDatesWithoutTime(DateMoving, DateReturnCargo, true) >= 0,
    ].every(fn => fn());

    const DayUtilization: boolean = [
      () => categoryOfWarehouseIn([ECategoryOfWarehouse.Branch], CategoryOfWarehouse),
      () => statusIn(invoiceStatuses, StatusCode),
      () => !DateReturnCargo,
      () => ActualDeliveryDate && compareStringDatesWithoutTime(updateDateFormat(moment(ActualDeliveryDate).add(25, 'days')), today, true) <= 0,
    ].every(fn => fn());

    if (DayUtilization) {
      this.displayedText = `Термін зберігання закінчується ${updateDateFormat(moment(ActualDeliveryDate).add(30, 'days'))}`;
      return;
    }

    if (AutoReturnPostomat) {
      this.displayedText = `Останній день зберігання в поштоматі – ${DateReturnCargo}. Потім ми повернемо посилку відправнику`;
      return;
    }

    if (AutoReturnStore) {
      this.displayedText = `Останній день зберігання в пункті – ${DateReturnCargo}. Потім ми повернемо посилку відправнику`;
      return;
    }

    if (LastDayPostomat) {
      this.displayedText = `Останній день зберігання в поштоматі – ${DateMoving}. Потім ми перемістимо посилку у відділення поблизу`;
      return;
    }

    if (LastDayStore) {
      this.displayedText = `Останній день зберігання в пункті – ${DateMoving}. Потім ми перемістимо посилку у відділення поблизу`;
      return;
    }
  }
}
